import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { TeachersMetricsPageController } from "./TeachersMetricsPageController"
import { TeachersMetricsPage } from "./TeachersMetricsPage"

export function TeachersMetricsPageDirective(): IDirective {
  return {
    restrict: "E",
    controller: "TeachersMetricsPageController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])
      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <TeachersMetricsPage
              controller={controller as TeachersMetricsPageController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
